import { render, staticRenderFns } from "./CircleNav.vue?vue&type=template&id=f5220d72&scoped=true&"
import script from "./CircleNav.vue?vue&type=script&lang=js&"
export * from "./CircleNav.vue?vue&type=script&lang=js&"
import style0 from "./CircleNav.vue?vue&type=style&index=0&id=f5220d72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5220d72",
  null
  
)

export default component.exports